// === NAPOSLEDY ZOBRAZENÉ PRODUKTY ===

const domainKey = window.location.hostname;
const storageKey = `recentProducts_${domainKey}`;
const maxProducts = 10;

// --- Pomocné funkce ---
function getStoredProducts() {
  try {
    return JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch {
    return [];
  }
}

function saveStoredProducts(data) {
  localStorage.setItem(storageKey, JSON.stringify(data));
}

function addProductToStorage() {
  const priceBox = $(".p-final-price-wrapper");
  let availabilityLabel = "";
  let availabilityAmount = "";
  let availabilityColor = "";
  const $selectedVariant = $(".variant-list select");

  if ($(".variant-list").length) {
    availabilityLabel = "Dle varianty";
    availabilityColor = "color:#000;";
  } else {
    const $availabilityValue = $(".p-info-wrapper .availability-value").first();
    const $availabilityLabel = $availabilityValue
      .find(".availability-label:not(.no-display)")
      .first();
    const $availabilityAmount = $availabilityValue
      .find(".availability-amount:not(.no-display)")
      .first();

    availabilityLabel = $availabilityLabel.text().trim() || "";
    availabilityAmount = $availabilityAmount.text().trim() || "";
    availabilityColor =
      $availabilityLabel.attr("style") || $availabilityValue.attr("style") || "";

    if (!availabilityLabel) {
      const $fallbackAvailability = $availabilityValue
        .find("span:not(.availability-amount):not(.no-display)")
        .first();
      availabilityLabel = $fallbackAvailability.text().trim() || "";
      availabilityColor = $fallbackAvailability.attr("style") || availabilityColor;
    }
  }

  // --- hvězdičky a počet recenzí ---
  const $rateAverageWrap = $(".rate-average-wrap .rate-star-wrap");
  const starCount = $rateAverageWrap.find(".star-on").length;
  const reviewCountText = $rateAverageWrap.find(".stars-label").text().trim();
  const reviewCount = reviewCountText.match(/\d+/) ? reviewCountText.match(/\d+/)[0] : 0;

  const variants = [];
  $(".variant-list select").each(function () {
    const $select = $(this);
    const paramName =
      $select.data("parameter-name") ||
      $select.closest("tr").find("th").text().trim();
    const options = [];
    $select.find("option").each(function () {
      const val = $(this).val();
      const text = $(this).text().trim();
      const isActive =
        $(this).is(":selected") || $(this).data("preselected") === true;
      if (val && !$(this).data("choose")) {
        options.push({
          id: val,
          text: text,
          index: $(this).data("index") || "",
          active: isActive,
        });
      }
    });

    if (options.length) {
      variants.push({
        name: paramName,
        options: options,
      });
    }
  });
 const $realThumbnails = $(".p-thumbnails-wrapper .p-thumbnails-inner").find("a.p-thumbnail");

function normalizeProductImage(src) {
  return (src || "")
    .replace("/big/", "/detail/")
    .replace("/related/", "/detail/");
}

const has360Image = $(".p-thumbnails-wrapper .p-thumbnails-inner .show360image").length > 0;

const productImg = has360Image
  ? normalizeProductImage($realThumbnails.eq(0).attr("href"))
  : normalizeProductImage($(".p-image a.p-main-image img").attr("src"));

const productImgSec = has360Image
  ? normalizeProductImage($realThumbnails.eq(1).attr("href"))
  : normalizeProductImage($realThumbnails.eq(1).attr("href"));


  const product = {
    url: window.location.pathname,
    domain: domainKey,
    name: $(".p-detail>.p-detail-inner>.p-detail-inner-header>h1")
      .text()
      .trim(),
    price: {
      standard: priceBox.find(".price-standard").html() || "",
      save: priceBox.find(".price-save").html() || "",
      final: priceBox.find(".price-final").html() || "",
      measure: priceBox.find(".price-measure").html() || "",
    },
    priceId: $("input[name=priceId]").val() || "",
    productId: $("input[name=productId]").val() || "",
    img: productImg,
imgSec: productImgSec,
    label:
      $(".product-top>.col-xs-12").first().find(".flags-default").html() || "",
    availability: availabilityLabel,
    availabilityLabel: availabilityLabel,
    availabilityAmount: availabilityAmount,
    availabilityColor: availabilityColor,
    starCount: starCount,
    reviewCount: reviewCount,
    shortDesc: $(".p-short-description p").first().text() || "",
    variants: variants,
  };
  let stored = getStoredProducts();
  stored = stored.filter((p) => p.url !== product.url);
  stored.unshift(product);
  if (stored.length > maxProducts) stored = stored.slice(0, maxProducts);
  saveStoredProducts(stored);
}

function renderRecentlyViewed() {
  const storedProducts = getStoredProducts();
  if (!storedProducts.length) return;

  const isRecentlyViewedPage = window.location.pathname === '/naposledy-prohlizene/';

  const rvContainer = $(`
    <div id="rvRecentlyViewed" class="rvRecentlyViewed ${isRecentlyViewedPage ? 'rvRecentlyViewedPage' : 'in-index'}">
      <div class="rvList products-block products"></div>
    </div>
  `);

  const $target = isRecentlyViewedPage
    ? $('.pageArticleDetail [itemprop="about"]').first()
    : $('.lastWiewProducts').first();

  if (!$target.length) return;

  if (!$target.find('#rvRecentlyViewed').length) {
    $target.append(rvContainer);
  }

  const $rvList = $target.find('#rvRecentlyViewed .rvList');


  storedProducts.forEach((p) => {
    const name = p.name || "";
    const img = p.img && !p.img.includes("undefined") ? p.img : "";
    const imgSec = p.imgSec && !p.imgSec.includes("undefined") ? p.imgSec : "";
    const label = p.label && !/undefined|null/.test(p.label) ? p.label : "";
    const availabilityLabel = p.availabilityLabel || p.availability || "";
    const availabilityAmount = p.availabilityAmount || "";

    // --- složení ceny z uložených částí ---
    const priceHtml = `
      <div class="prices">
        ${p.price.standard ? `<span class="price-standard">${p.price.standard}</span>` : ""}
        ${p.price.final ? `<div class="price price-final"><strong>${p.price.final}</strong></div>` : ""}
      </div>
    `;

    // --- dostupnost ---
    const availabilityHtml = availabilityLabel || availabilityAmount
      ? `
      <div class="availability">
        ${availabilityLabel ? `<span class="availability-label" style="${p.availabilityColor || ""}">${availabilityLabel}</span>` : ""}
        ${availabilityAmount ? `<span class="availability-amount">${availabilityAmount}</span>` : ""}
      </div>
    `
      : "";

    // --- hvězdičky ---
    let starsHtml = `
      <div class="stars-wrapper" data-micro-rating-value="0" data-micro-rating-count="0">
        <span class="stars star-list stars-list">
          <span class="star star-off" aria-hidden="true"></span>
          <span class="star star-off" aria-hidden="true"></span>
          <span class="star star-off" aria-hidden="true"></span>
          <span class="star star-off" aria-hidden="true"></span>
          <span class="star star-off" aria-hidden="true"></span>
          <span class="sr-only">Průměrné hodnocení produktu je 0,0 z 5 hvězdiček.</span>
        </span>
        <div class="rating-meta"><strong>0 z 5</strong></div>
      </div>
    `;
    if (p.starCount) {
      const stars = Array(5)
        .fill(0)
        .map((_, i) => `<span class="star ${i < p.starCount ? "star-on" : "star-off"}" aria-hidden="true"></span>`)
        .join("");
      starsHtml = `
      <div class="stars-wrapper" data-micro-rating-value="${p.starCount}" data-micro-rating-count="${p.reviewCount || 0}">
        <span class="stars star-list stars-list">
          ${stars}
          <span class="sr-only">Průměrné hodnocení produktu je ${p.starCount},0 z 5 hvězdiček.</span>
        </span>
        ${p.reviewCount ? `<div class="rating-meta"><strong>${p.starCount} z 5</strong><span>${p.reviewCount} ${p.reviewCount === 1 ? "recenze" : "recenzí"}</span></div>` : ""}
      </div>
    `;
    }

    // --- finální HTML produktu ---
    const rvItem = `
      <div class="product lastWiew">
        <div class="p ${imgSec ? "swap-images" : ""}" data-micro="product" data-testid="productItem">
          <a href="${p.url}" class="image">
            <img src="${img}" data-src="${img}" ${imgSec ? `data-next="${imgSec}" class="swap-image"` : ""} alt="${name}" loading="lazy">
         
            <div class="flags flags-default">${label || ""}</div>
          </a>

          <div class="p-in">
            <div class="p-in-in">
              <a href="${p.url}" class="name" data-micro="url">
                <span data-micro="name" data-testid="productCardName">${name}</span>
              </a>
              <div class="ratings-wrapper">
                ${starsHtml}
              </div>
              ${availabilityHtml}
            </div>

            <div class="p-bottom single-button no-buttons">
              <div data-micro="offer">
                ${priceHtml}
                ${p.shortDesc ? `<div class="p-desc">${p.shortDesc}</div>` : ""}
                <div class="p-tools"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    $rvList.append(rvItem);
  });

  // special availability textace

  $rvList.find(".product").each(function () {
    const $product = $(this);
    const availabilityText = $product
      .find(".availability > span:not(.availability-amount)")
      .text()
      .trim()
      .toLowerCase();

    const deliveryDate = getDeliveryDateByAvailability(availabilityText);
    if (!deliveryDate) return;

    const formatted = formatDeliveryDate(deliveryDate, false);

    $product
      .find(".availability")
      .append(`<div class="deliveryDate">${formatted} u tebe</div>`);
  });


 if (!isRecentlyViewedPage) {
  setTimeout(() => {
    const $block = $(".rvRecentlyViewed .products-block");

    if (typeof $.fn.slick !== "undefined" && $block.length) {
      if ($block.hasClass("slick-initialized")) {
        $block.slick("unslick");
      }

      $block.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
          { breakpoint: 1199, settings: { slidesToShow: 3.5 } },
          { breakpoint: 991, settings: { slidesToShow: 2.5 } },
          { breakpoint: 479, settings: { slidesToShow: 1.5 } },
        ],
      });
    }
  }, 100);
}
}
if ($(".type-detail").length) {
  addProductToStorage();
}
